/**
 * Afterpay on-site messaging renders as a <square-placement> web component
 * whose content lives inside a shadow root. Theme/global CSS cannot pierce
 * shadow DOM and the app exposes no ::part() hooks, so spacing tweaks must be
 * injected into each widget's shadow root directly.
 */
(function () {
  var SHADOW_CSS = '.afterpay-main-text{padding-right:7px !important;}';
  var MARKER = 'data-tw-afterpay-spacing';

  function inject(el) {
    if (!el || !el.shadowRoot) return;
    if (el.shadowRoot.querySelector('style[' + MARKER + ']')) return;
    var style = document.createElement('style');
    style.setAttribute(MARKER, '');
    style.textContent = SHADOW_CSS;
    el.shadowRoot.appendChild(style);
  }

  function scan() {
    document.querySelectorAll('square-placement').forEach(inject);
  }

  scan();

  // Widget loads asynchronously; re-scan on DOM changes...
  var observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // ...plus bounded fallbacks in case the shadow root fills after the mutation.
  [300, 800, 1500, 3000].forEach(function (t) { setTimeout(scan, t); });
  window.addEventListener('load', scan);
})();
